import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row q-gutter-lg q-py-md" }
const _hoisted_3 = { class: "text-caption q-mb-sm" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 0,
  class: "text-caption q-mt-sm"
}

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InstitutionalImagesSection',
  setup(__props) {

const institutionalStore = useInstitutionalStore()

/*const imagens = computed(() => {
  return institutionalStore.institutionalDetail?.imagens?.length
    ? institutionalStore.institutionalDetail.imagens
    : institutionalStore.imagensDraft
})*/

const imagens = computed(() => institutionalStore.imagensDraft)

const getNomePosicaoImagem = (posicao: number) => {
  const mapa: Record<number, string> = {
    1: 'Tela Inicial 1',
    2: 'Tela Inicial 2',
    3: 'Tela Inicial 3',
    4: 'Tela Inicial 4',
    5: 'Tela de Abertura',
    6: 'Tela de Aguarde e Leitura do Cartão (Geral)',
    7: 'Tela de Aguarde e Leitura do Cartão (Apenas Cartões com Chip)',
    8: 'Botão ATM - Sacar sem cartão',
    9: 'Botão ATM - Recarga celular',
    10: 'Botão ATM - Mais serviços',
    11: 'Botão ATM - Depositar dinheiro'
  }

  return mapa[posicao] || `Posição ${posicao}`
}


return (_ctx: any,_cache: any) => {
  const _component_c_q_separator = _resolveComponent("c-q-separator")!

  return (imagens.value && imagens.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_c_q_separator, { class: "q-pt-lg q-pb-md" }),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row q-pb-xs" }, [
          _createElementVNode("span", { class: "midia-app-label-sm" }, "Imagens Configuradas")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imagens.value, (imagem) => {
            return (_openBlock(), _createElementBlock("div", {
              key: imagem.posicaoImagem,
              class: "column items-center"
            }, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(getNomePosicaoImagem(imagem.posicaoImagem)), 1),
              _createElementVNode("img", {
                src: imagem.urlS3 ? imagem.urlS3 : imagem.urlPreview,
                style: {"width":"120px","height":"120px","object-fit":"cover","border-radius":"4px","border":"1px solid #e0e0e0"},
                alt: `Imagem posição ${imagem.posicaoImagem}`
              }, null, 8, _hoisted_4),
              ([1, 2, 3, 4].includes(imagem.posicaoImagem))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Duração: " + _toDisplayString(imagem.duracaoImagem) + "s ", 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})